import { UsuariosService } from './../../services/usuarios.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  paginaActual:number=1;
  paginaSiguiente:number;
  paginaAnterior:number;
  totalPaginas:number;

  usuarios:any[]=[];

  filtro:{}={
    nombre:"",
    email:"",
    telefono:"",
    perfil:0,
    activo:true,
    ultimoacceso:""
  };

  ordenacion={};
  

  constructor(private _usuariosService:UsuariosService) { }

  ngOnInit() {

    this.ordenacion['campo']="USfechaultimoacceso";
    this.ordenacion['orden']="DESC";

    this._usuariosService.getPerfilesUsuario().subscribe();
    this.getUsuariosPorFiltro(this.paginaActual);
    
  }

  getUsuariosPorFiltro(pagina){
    
    this._usuariosService.getUsuarios(this.filtro, pagina, this.ordenacion)
          .subscribe(resp=>{
            this.usuarios=resp["usuarios"];
            this.paginaActual=parseInt(resp["pagina"]);
            this.paginaAnterior=parseInt(resp["pag_anterior"]);
            this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
            this.totalPaginas=parseInt(resp["total_paginas"]);
          });
  }

  checkActivo(i:number){
    let returnValue=false;
    if(this.usuarios[i].USactivo=="1"){
      returnValue=true;
    }
    return returnValue;
  }

  nextPage(){
    this.getUsuariosPorFiltro(this.paginaSiguiente);
  }

  previousPage(){
    this.getUsuariosPorFiltro(this.paginaAnterior);
  }

  limpiarCampos(){
    this.filtro={
      nombre:"",
      email:"",
      telefono:"",
      perfil:0,
      activo:true,
      ultimoacceso:""
    };
   

  }

  verTodos(){
    this.limpiarCampos();
    this.getUsuariosPorFiltro(this.paginaActual);
  }

  actualizarEstado(codigo){
    if(confirm("¿Desea cambiar el estado del usuario seleccionado?")){
      this._usuariosService.actualizarEstado(codigo)
      .subscribe(resp=>{
        this.getUsuariosPorFiltro(this.paginaActual);
      })
    }
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    

    this.getUsuariosPorFiltro(this.paginaActual);
  }

  borrarUsuario(codUsuario){
    if(confirm("¿Desea borrar el usuario seleccionado?")){
      this._usuariosService.borrarUsuario(codUsuario)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.getUsuariosPorFiltro(this.paginaActual);
      });
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/components/usuarios/usuarios.component.ts